import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import routes from '../routes';
import { GlobalErrorHandler } from '@error-handling/global-error.handler';
import { ErrorInterceptor } from '@error-handling/error.interceptor';
import { AuthInterceptor, TranslationService, WINDOW } from '@ess-front/shared';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslationDomainService } from '@shared/domain/translation-domain.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule, MatSnackBarModule, MatDialogModule),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, // should be before AuthInterceptor
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: WINDOW, useValue: window },
    {
      provide: TranslationService,
      useClass: TranslationDomainService,
    },
    { provide: WINDOW, useValue: window },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideAnimationsAsync(),
  ],
};
